import React from 'react';
import { useNavigate } from 'react-router-dom';
import not_found from '../assets/not_found.svg'; // Example image

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-800">
      <img src={not_found} alt="Page Not Found" className="w-1/2 mb-6" />
      <p className="text-xl mb-6">Sorry, we couldn't find the page you're looking for.</p>
      <button
        onClick={() => navigate('/')}
        className="px-6 py-3 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 transition"
      >
        Go Home
      </button>
    </div>
  );
};

export default NotFound;
